import arrayReduce from './arrayReduce';

export default function applyMediaRulesInOrder(order) {
  return arrayReduce(order, function (mediaMap, query) {
    mediaMap[query] = '';
    return mediaMap;
  }, {});
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/fela-plugin-named-media-query/node_modules/fela-utils/es/applyMediaRulesInOrder.js
// module id = 45
// module chunks = 0